// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Ödeme Analizi',
  subtitle: 'Ödeme istatistikleri ve analizleri',
  totalRevenue: 'Toplam Gelir',
  totalExpense: 'Toplam Gider',
  netProfit: 'Net Kar',
  averagePayment: 'Ortalama Ödeme',
  paymentCount: 'Ödeme Sayısı',
  byMonth: 'Aylık',
  byYear: 'Yıllık',
  byCompany: 'Şirkete Göre',
  byType: 'Tipe Göre',
  noData: 'Analiz verisi bulunmuyor',
  fetchError: 'Analiz verileri alınamadı',
  currency: 'Para Birimi',
  analysisView: 'Analiz Görünümü',
  byCompanyAnalysis: 'Şirkete Göre Analiz',
  byCustomer: 'Müşteriye Göre',
  byCustomerAnalysis: 'Müşteriye Göre Analiz',
  totalPurchase: 'Toplam Alış',
  totalSale: 'Toplam Satış',
  totalProfit: 'Toplam Kar',
  totalPayments: 'Toplam Ödeme',
  purchase: 'Alış',
  sale: 'Satış',
  profit: 'Kar',
  company: 'Şirket',
  customer: 'Müşteri',
  packageName: 'Paket Adı',
  packageType: 'Paket Tipi',
  type: 'Tip',
  frequency: 'Sıklık',
  paymentDetails: 'Ödeme Detayları',
  details: 'Detaylar',
  hide: 'Gizle',
  noPayments: 'Ödeme bulunmuyor',
  noPaymentsDesc: 'Henüz ödeme kaydı yok.',
  unknownCompany: 'Bilinmeyen Şirket',
  unknownCustomer: 'Bilinmeyen Müşteri',
  unassignedCustomer: 'Atanmamış',
  sheetName: 'Ödeme Analizi',
  exportSuccess: 'Veriler başarıyla dışa aktarıldı'
};
